// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ff5e6a9","389":"45c913f0","732":"29cddded","857":"5d8ce310","977":"87ce1242"}[chunkId] + ".chunk.js";
};